import { useTranslation } from "react-i18next";
import CollapsibleCard, {
  CARD_CONTENT_TYPES,
} from "../pages/attendance-system/CollapsibleCard";
import CustomInput from "./CustomInput";
import ViewEditDiv from "./ViewEditDiv";
import SectionDivider from "./SectionDivider";
import SectionDividerWithNoLine from "./SectionDividerWithNoLine";

const SubCompanyAdditionalInfoSection = ({
  additionalInfoState,
  handleChangeAdditionalInfo,
  isEditing = true,
}) => {
  const { t } = useTranslation("general");

  const divClasses =
    "o-row o-row--vertical-align_center o-row--gap-size_500 u-width_full-width";
  const pClasses = "t-bold_semi-bold u-width-specific_150 u-margin_0";

  const additionalInfo = [
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="addressInAr"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="addressInAr"
              value={additionalInfoState?.addressInAr}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="countryCode"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="countryCode"
              value={additionalInfoState?.countryCode}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="commercialCompanyType"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="commercialCompanyType"
              value={additionalInfoState?.commercialCompanyType}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="certificateIssueDate"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="certificateIssueDate"
              type="date"
              value={additionalInfoState?.certificateIssueDate}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="registrationNumber"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="registrationNumber"
              value={additionalInfoState?.registrationNumber}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="originatorType"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="originatorType"
              value={additionalInfoState?.originatorType}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="businessSector"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="BusinessSector"
              value={additionalInfoState?.BusinessSector}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="typeOfGoods"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="typeOfGoods"
              value={additionalInfoState?.typeOfGoods}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="generalPurpose"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="generalPurpose"
              value={additionalInfoState?.generalPurpose}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="purposeDetails"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="purposeDetails"
              value={additionalInfoState?.purposeDetails}
              onChange={handleChangeAdditionalInfo}
              flex={true}
              multiline={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.SECTION_HEADER,
      element: <SectionDividerWithNoLine title="spcifySuppliers" />,
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="supplier1"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="supplier1"
              value={additionalInfoState?.supplier1}
              onChange={handleChangeAdditionalInfo}
              flex={true}
              multiline={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="supplier2"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="supplier2"
              value={additionalInfoState?.supplier2}
              onChange={handleChangeAdditionalInfo}
              flex={true}
              multiline={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="supplier3"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="supplier3"
              value={additionalInfoState?.supplier3}
              onChange={handleChangeAdditionalInfo}
              flex={true}
              multiline={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="estimatedPaymentsCountPerQuarter"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="estimatedPaymentsCountPerQuarter"
              value={additionalInfoState?.estimatedPaymentsCountPerQuarter}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="estimatedPaymentsValuePerQuarter"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="estimatedPaymentsValuePerQuarter"
              value={additionalInfoState?.estimatedPaymentsValuePerQuarter}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="numberOfEmployees"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="numberOfEmployees"
              value={additionalInfoState?.numberOfEmployees}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="annualRevenue"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="annualRevenue"
              value={additionalInfoState?.annualRevenue}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.SECTION_HEADER,
      element: <SectionDividerWithNoLine title="significantParties" />,
    },

    // Senior Managing Official Section
    {
      type: CARD_CONTENT_TYPES.SECTION_HEADER,
      element: <SectionDivider title="seniorManagingOfficial" />,
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sFirstNameInAr"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sFirstNameInAr"
              value={additionalInfoState?.sFirstNameInAr}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sLastNameInAr"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sLastNameInAr"
              value={additionalInfoState?.sLastNameInAr}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="firstNameInEn"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sFirstName"
              value={additionalInfoState?.sFirstName}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="lastNameInEn"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sLastName"
              value={additionalInfoState?.sLastName}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sDateOfBirth"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sDateOfBirth"
              type="date"
              value={additionalInfoState?.sDateOfBirth}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sPhoneNumber"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sPhoneNumber"
              value={additionalInfoState?.sPhoneNumber}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sAddress"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sAddress"
              value={additionalInfoState?.sAddress}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sCity"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sCity"
              value={additionalInfoState?.sCity}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sCountry"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sCountry"
              value={additionalInfoState?.sCountry}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sPosition"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sPosition"
              value={additionalInfoState?.sPosition}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sIsOwner"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sIsOwner"
              value={additionalInfoState?.sIsOwner}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sOwnerPercentage"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sOwnerPercentage"
              value={additionalInfoState?.sOwnerPercentage}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sIsAuthorizedSignatory"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sIsAuthorizedSignatory"
              value={additionalInfoState?.sIsAuthorizedSignatory}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="sidType"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="sidType"
              value={additionalInfoState?.sidType}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    // Authorized Signatory Section
    {
      type: CARD_CONTENT_TYPES.SECTION_HEADER,
      element: <SectionDivider title="authorizedSignatory" />,
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aFirstNameInAr"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aFirstNameInAr"
              value={additionalInfoState?.aFirstNameInAr}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aLastNameInAr"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aLastNameInAr"
              value={additionalInfoState?.aLastNameInAr}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="firstNameInEn"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aFirstName"
              value={additionalInfoState?.aFirstName}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="lastNameInEn"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aLastName"
              value={additionalInfoState?.aLastName}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },

    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aDateOfBirth"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aDateOfBirth"
              type="date"
              value={additionalInfoState?.aDateOfBirth}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aPhoneNumber"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aPhoneNumber"
              value={additionalInfoState?.aPhoneNumber}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aAddress"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aAddress"
              value={additionalInfoState?.aAddress}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aCity"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aCity"
              value={additionalInfoState?.aCity}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aCountry"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aCountry"
              value={additionalInfoState?.aCountry}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aIsOwner"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aIsOwner"
              value={additionalInfoState?.aIsOwner}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aOwnerPercentage"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aOwnerPercentage"
              value={additionalInfoState?.aOwnerPercentage}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aIsAuthorizedSeniorManaging"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aIsAuthorizedSeniorManaging"
              value={additionalInfoState?.aIsAuthorizedSeniorManaging}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aIdType"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aIdType"
              value={additionalInfoState?.aIdType}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
    {
      type: CARD_CONTENT_TYPES.EDITABLE,
      element: (
        <ViewEditDiv
          title="aIdNumber"
          divClasses={divClasses}
          pClasses={pClasses}
          editMode={isEditing}
          InputElement={
            <CustomInput
              name="aIdNumber"
              value={additionalInfoState?.aIdNumber}
              onChange={handleChangeAdditionalInfo}
              flex={true}
            />
          }
        />
      ),
    },
  ];

  return (
    <CollapsibleCard
      title={t("additionalInfo")}
      content={additionalInfo}
      isEditing={isEditing}
    />
  );
};

export default SubCompanyAdditionalInfoSection;
